import { createFileRoute } from "@tanstack/react-router";
import { ForecastingBookPage } from "./forecasting.contracts";

export const Route = createFileRoute("/forecasting/month-view")({
  component: ForecastMonthViewRoute,
});

function ForecastMonthViewRoute() {
  return <ForecastingBookPage view="month" />;
}
